<template>
                
  <index-nine-banner />

  <index-nine-featured />

  <index-nine-categories />

  <index-nine-testimonial />

  <index-nine-partner />

  <index-nine-service />

  <index-nine-app />

  <index-nine-footer />

</template>

<script>
export default {
  mounted() {
    this.updateBodyClass();
  },
  watch: {
    // Watch for route changes
    $route() {
      this.updateBodyClass();
    }
  },
  methods: {
    updateBodyClass() {
      if (this.$route.path.includes("/home/index-9")) {
        document.body.classList.add("home-page-five");
      } else {
        document.body.classList.remove("home-page-five");
      }
    }
  }
};
</script>